import { render, staticRenderFns } from "./PadletLogo.vue?vue&type=template&id=7d4949c9&"
import script from "./PadletLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PadletLogo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports